<script>
/* eslint-disable */
// import {UContextMenu} from 'uloc-vue'
import {atualizarTicket, defineKm} from '../../../../domain/callcenter/services'
import printError from '../../../../utils/printError'
import ClickOut from '../../../../utils/directives/clickout'

export default {
  name: 'ContextMenuRemocaoTicket',
  props: ['remocao'],
  directives: {ClickOut},
  data () {
    return {
      open: false,
      atualizando: false
    }
  },
  computed: {},
  methods: {
    toggle () {
      this.open = !this.open
    },
    hide () {
      this.open = false
    },
    acao (acao) {
      this.atualizando = true
      console.log('click')
      atualizarTicket(this.remocao.id, acao)
        .then((response) => {
          let data = response.data
          console.log(data)
          this.atualizando = false
          this.remocoes = data
        })
        .catch((response) => {
          this.atualizando = false
          /* this.$uloc.notify({
            color: 'negative',
            message: `Erro ao tentar atualizar a remoção "${printError(response)}"`
          }) */
          alert(`Erro ao tentar atualizar a remoção "${printError(response)}"`)
        })
      // this.$refs.context.hide()
    },
    definirKm (tipo) {
      // this.$refs.context.hide()
      let km = prompt('Digite o KM ' + (tipo === 'final' ? 'Final' : 'Inicial'))
      if (km === null) {
        alert('Ok, mas lembre-se que esta informação é de suma importância')
        return
      }

      defineKm(this.remocao.id, tipo, String(km).replace(/\D/, ''))
        .then((response) => {
          let data = response.data
          console.log(data)
          // this.$uloc.notify({color: 'positive', message:`Definido com sucesso!`})
          alert(`Definido com sucesso!`)
        })
        .catch((response) => {
          /* this.$uloc.notify({
            color: 'negative',
            message: `Erro ao tentar atualizar a remoção "${printError(response)}"`
          }) */
          alert(`Erro ao tentar atualizar a remoção "${printError(response)}"`)
        })
    }
  },
  components: {}
}
</script>

<template>
  <!--<u-context-menu ref="context" class="def-context-menu">-->
  <div class="btn-group dropdown pos-abt" style="top: 0px; right: 2px" :class="{ open: open}" v-click-out="hide">
    <button class="btn btn-sm" data-toggle="dropdown" tabindex="1" aria-expanded="false" @click.stop.prevent="toggle">
      <!--<i class="fa fa-terminal m-r-xs"></i>--> Ações <span class="m-l-sm caret"></span>
    </button>
    <ul class="dropdown-menu dropdown-menu-right no-padder">
      <!-- <li v-if="!remocao.kmInicial">
        <a @click="definirKm('inicial')">
          <i class="fa fa-tachometer-alt-slowest" />
          Definir KM inicial
        </a>
      </li>
      <li v-else>
        <div class="wrapper-sm">KM Inicial: {{remocao.kmInicial}} km</div>
      </li> -->
      <li v-if="remocao.etapa < 2">
        <a @click="acao('recolher')">
          <!--<u-icon name="truck-ramp" type="fa" icon-style="light"
                  color="orange"></u-icon>-->
          Iniciar Recolhimento
        </a>
      </li>
      <li :disabled="remocao.etapa < 2" v-if="remocao.etapa < 3">
        <a @click="remocao.etapa === 2 && acao('transportar')">
          <!--<u-icon name="road" type="fa" icon-style="light"
                  color=""></u-icon>-->
          Iniciar Transporte
        </a>
      </li>
      <!-- <li v-if="!remocao.kmFinal">
        <a @click="definirKm('final')">
          
          Definir KM final
        </a>
      </li>
      <li v-else>
        <div class="wrapper-sm">KM Final: {{remocao.kmFinal}} km</div>
      </li> -->
      <li :disabled="remocao.etapa < 3" v-if="remocao.etapa < 4">
        <a @click="remocao.etapa === 3 && acao('entregar')">
          <i class="fa fa-check-square text-success"></i>
          Entregar
        </a>
      </li>
    </ul>
  </div>
  <!--</u-context-menu>-->
</template>



// WEBPACK FOOTER //
// remocao-ticket.vue?725706cf